import Logger from './Logger';

export default class FontManager {
	static LoadFont(fontName, fontUrl) {
		return new Promise((resolve, reject) => {
			const newFont = new FontFace(fontName, `url(${fontUrl})`);

			newFont.load().then((loadedFont) => {
				Logger.log(`FontManager: loaded font ${fontName}...`);
				document.fonts.add(loadedFont);
				resolve();
			}).catch((error) => {
				reject(error);
			});
		});
	}

	static DeleteUnusedFonts(used) {
		const fonts = [...document.fonts];

		for (let i = 0; i < fonts.length; i++) {
			if (used.indexOf(fonts[i].family) === -1) {
				Logger.log(`FontManager: deleting unused font ${fonts[i].family}...`);
				document.fonts.delete(fonts[i]);
			}
		}
	}

	static DeleteFont(fontName) {
		return document.fonts.delete(fontName);
	}
}
